import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/services/login.service';
import jwt_decode from "jwt-decode";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-confirma',
  templateUrl: './confirma.component.html',
  styleUrls: ['./confirma.component.css']
})
export class ConfirmaComponent implements OnInit {


  showPage: boolean = false;
  instrucao: any;
  token: any;
  idEleicao: number;
  eleicaoRota: any;
  loginService: LoginService;
  informacoesToken: any;

  @Input() logoEleicao: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    protected auth: LoginService,
    protected messageService: MessageService,
    protected eleicaoService: EleicaoService
  ) {
    this.eleicaoRota = this.route.snapshot.params.eleicaoRota;
  }

  ngOnInit() {
    this.instrucao = "A eleição está em período de candidaturas. ";
    var formularioPreenchido = sessionStorage.getItem("formularioPreenchido") === "true";
    this.instrucao = this.instrucao + (formularioPreenchido ? "Você já se candidatou. Para editar a candidatura, confirme abaixo."
    : "Para se candidatar, confirme abaixo.");
    this.route.params.subscribe(async params => {
      if (params.rotaEleicao && params.rotaEleicao != "gestor" && params.rotaEleicao != "admin" ) {
        this.getLogo(params.rotaEleicao);
      }
    });
    this.getLogo(this.eleicaoRota);
    this.spinner.hide();
  }

  public getTermoAceitoAvancar() {
    this.spinner.show();
    this.router.navigate(['../precandidato'], { relativeTo: this.route })
  }

  async getLogo(rota: string) {
    try {
      const request = await this.eleicaoService.getLogoByRotaEleicao(rota).toPromise();
      if (request) {
        this.eleicaoService.logoEleicao = request;
        sessionStorage.setItem('logoEleicao', request);
      }
    } catch( error ) {
      console.log( error );
    }
  }
}
